import { InventObject } from './InventObject.ts'
import type { InventoryMapObjectData, InventoryMapObjectTypes } from '@/widgets'
import { centerOfMass, polygon } from '@turf/turf'

export default class InventObjectPolygon extends InventObject {
  constructor(objectData: InventoryMapObjectData, objectType: InventoryMapObjectTypes) {
    super(objectData, objectType)

    this.feature = polygon([objectData.coordinates], this.properties)
    this.geometry = this.feature.geometry
  }

  public transformCoords(coords: any) {
    return coords[0]
  }

  public getLabelCoords(): number[] {
    return centerOfMass(this.feature).geometry.coordinates
  }

  public getTransformCoords(): number[][] {
    const coords = this.feature.geometry.coordinates[0] as []
    return coords.slice(0, coords.length - 1) as [][]
  }

  public getFeatureCoords(): number[] {
    return this.feature.geometry.coordinates[0] as any[]
  }

  public setTransformPointsCoords(coords: any[]) {
    this.feature.geometry = { ...this.feature.geometry, coordinates: [coords] }
  }

  public setTransformPointCoords(index: number, coords: []) {
    const ring = [...(this.feature.geometry.coordinates[0] as any[])]
    if (index === 0) {
      ring[ring.length - 1] = coords
    }
    ring[index] = coords
    this.feature.geometry = { ...this.feature.geometry, coordinates: [ring] }
  }

  public deletePoint(index: number) {
    const ring = [...(this.feature.geometry.coordinates[0] as any[])]
    ring.splice(index, 1)
    this.feature.geometry = { ...this.feature.geometry, coordinates: [ring] }
  }
}
